/**
 * ลิงก์ข้าม module ไปหน้าบริษัท — หน้าเต็มตั้งแต่ 28 ต.ค. 2026 (เดิมเป็นโมดัลในหน้ารายการ)
 *   /master-data/companies          รายการ
 *   /master-data/companies/:id      รายละเอียด (companies.view)
 *   /master-data/companies/:id/edit แก้ไข (companies.view + companies.edit)
 *   /master-data/companies/new      เพิ่มใหม่ (companies.create)
 * ใช้ helper นี้ทุกที่ที่ลิงก์ไปบริษัท เพื่อให้ URL contract อยู่ที่เดียว (แบบ utils/siteLinks.ts)
 */
export const COMPANIES_PATH = '/master-data/companies';

/** หน้ารายละเอียดบริษัท — id ไม่ถูกต้อง = หน้ารายการ */
export function companyDetailUrl(companyId: number | string | null | undefined): string {
  const n = Number(companyId);
  return Number.isInteger(n) && n > 0 ? `${COMPANIES_PATH}/${n}` : COMPANIES_PATH;
}

export function companyEditUrl(companyId: number | string | null | undefined): string {
  const url = companyDetailUrl(companyId);
  return url === COMPANIES_PATH ? url : `${url}/edit`;
}
